import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [SelectComponent],
    exports: [SelectComponent],
    imports: [CommonModule, FormsModule, RouterModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class SelectModule {}
